import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import ContactBetnav from "./sections/ContactBetnav";
import InTheNeighborhood from "./sections/InTheNeighborhood";
import DuvidasFrequentes from "./sections/DuvidasFrequentes";
import FooterInfo from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <ContactBetnav />
      <InTheNeighborhood />
      <DuvidasFrequentes />
      <FooterInfo />
    </div>;
}